import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';

import Terminal from './component/AllTerminals';
import Locations from './component/Locations/component/LocationList';
import Services from './component/Services/components/ServiceList';
import ProductTerminals from '../Settings/components/Products';

type Props = {
  location: {
    pathname: string
  },
};

const Terminals = (props: Props) => {
  const {
    location,
  } = props;
  const [current, setCurrent] = useState('transactions');

  const setMenu = (query) => {
    switch (query) {
      case '/terminals': {
        setCurrent('terminals');
        break;
      }
      case '/terminals/locations': {
        setCurrent('locations');
        break;
      }
      case '/terminals/services': {
        setCurrent('services');
        break;
      }
      case '/terminals/productsterminals': {
        setCurrent('productsterminals');
        break;
      }
      default:
        setCurrent('terminals');
    }
  };

  useEffect(() => {
    setMenu(location.pathname);
  }, [location]);

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal" style={{ fontSize: '20px' }}>
        <Menu.Item key="terminals">
          <SpTab
            to="/terminals"
            selected={current === 'terminals'}
          >
            Terminals
          </SpTab>
        </Menu.Item>
        <Menu.Item key="locations">
          <SpTab
            to="/terminals/locations"
            selected={current === 'locations'}
          >
            Locations
          </SpTab>
        </Menu.Item>
        <Menu.Item key="services">
          <SpTab
            to="/terminals/services"
            selected={current === 'services'}
          >
            Services
          </SpTab>
        </Menu.Item>
        <Menu.Item key="productsterminals">
          <SpTab
            to="/terminals/productsterminals"
            selected={current === 'productsterminals'}
          >
            Catalog
          </SpTab>
        </Menu.Item>
      </Menu>
      <Switch>
        <Route exact path="/terminals" component={Terminal} />
        <Route exact path="/terminals/locations" component={Locations} />
        <Route exact path="/terminals/services" component={Services} />
        <Route exact path="/terminals/productsterminals" component={ProductTerminals} />
      </Switch>
    </div>
  );
};

export default withRouter(Terminals);
